export default {
  getStateCountry: state => state.stateCountry,
  getPOS: state => state.pos,
  getSeller: state => state.seller,
  getCaptation: state => state.captation,
  getCaptionName: state => state.captationName,
  getWallet: state => state.wallet,
  getPosCnpj: state => state.posCnpj,
}
